<button
  id="open-business-account"
  (click)="trigger.emit()"
  class="ibk-btn ibk-btn--primary trigger__btn ba-btn"
  [ngClass]="{ 'ibk-btn--no-bg': !filled }"
>
  <img [src]="asset('assets/images/ibk-icon' + (filled ? '-white' : '') + '.svg')" alt="Interbank" class="icon" />
  Abre tu Cuenta Negocios
  <img class="logo" [src]="asset('assets/images/ibk-logo' + (filled ? '-white' : '') + '.svg')" alt="Interbank" />
</button>
